<template>
    <div class="products">
        <div class="data-container">
            <b-table
                show-empty
                :items="isSearching ? [] : storeVouchers"
                :fields="fields"
                :empty-text="(loading) ? 'Loading...' : emptyText"
                responsive>
                <template slot="voucher_type" slot-scope="row" >
                    <span class="text-capitalize">{{ row.value }}</span>
                </template>
                <template slot="value" slot-scope="row">
                    
                    <template v-if="row.item.value_type == 'php'">
                        Php {{ row.value | toCurrency }}
                    </template>
                    <template v-else>
                        {{ row.value | toCurrency }} %
                    </template>
                </template>
                <template slot="code_count" slot-scope="row">
                    <template v-if="row.item.voucher_type == 'generic'">
                        {{ row.item.uses + '/' + row.item.code_quantity }}

                        <template></template><template></template>
                    </template>
                    <template v-else>
                        {{ row.item.voucher_codes_remaining }}
                    </template>
                </template>
                <template slot="uuid" slot-scope="row">
                    <switches 
                        v-model="row.item.visibility"
                        theme="custom"
                        color="primary"
                        text-enabled="On"
                        text-disabled="Off"
                        type-bold="true"
                        style="top: 0;"
                        disabled>
                    </switches>
                </template>
                <template slot="action" slot-scope="row">
                    <b-button v-if="row.item.voucher_type == 'unique'" variant="ghost" class="shadow-none px-0" @click="callViewStoreVouchers({
                        name: row.item.name, uuid: row.item.uuid
                    })">
                        <i class="action-button">
                            <img src="@/assets/images/actions/search.svg" alt="View">
                        </i>
                    </b-button>
                    <b-button variant="ghost" class="shadow-none px-0" @click="callEditModal({
                        uuid: row.item.uuid
                    })">
                        <i class="action-button">
                            <img src="@/assets/images/actions/edit.svg" alt="Edit">
                        </i>
                    </b-button>
                    <b-button variant="ghost" class="shadow-none px-0" @click="callDeleteModal({
                        name: row.item.name, uuid: row.item.uuid
                    })">
                        <i class="action-button">
                            <img src="@/assets/images/actions/delete.svg" alt="Delete">
                        </i>
                    </b-button>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import Switches from "vue-switches";

export default {
    name: "StoreVoucherTable",
    components: {
        Switches
    },
    computed: {
        ...mapState("estoreVouchers", [
            "loading",
            "storeVouchers",
            "emptyText",
            "isSearching"
        ])
    },
    data() {
        return {
            fields: [
                {
                    key: "name",
                    label: "Store Voucher Name",
                    sortable: true,
                    thClass: "text-left",
                    tdClass: "text-left"
                },
                {
                    key: "voucher_type",
                    sortable: true,
                    label: "Voucher Type"
                },
                { key: "value", sortable: true },
                {
                    sortable: true,
                    key: "code_count"
                },
                { key: "uuid", label: "Visibility", sortable: false },
                { key: "action", sortable: false }
            ]
        };
    },
    created() {
        this.getStoreVouchers(1);
    },
    methods: {
        callEditModal: async function(obj) {
            let _this = this;
            await this.$store
                .dispatch("estoreVouchers/viewStoreVoucher", obj.uuid)
                .then(() => {
                    _this.$store.commit("estoreVouchers/setModal", {
                        type: "edit",
                        status: true,
                        uuid: obj.uuid
                    });
                });
        },
        callDeleteModal: function(obj) {
            this.$store.commit("estoreVouchers/setModal", {
                type: "delete",
                status: true,
                name: obj.name,
                uuid: obj.uuid
            });
        },
        callViewStoreVouchers: async function(obj) {
            let param = {
                page: 1,
                payload: {
                    store_voucher_uuid: obj.uuid,
                    filters: null
                }
            };

            let _this = this;
            await this.$store
                .dispatch("estoreVouchers/viewStoreVoucherCodes", param)
                .then(() => {
                    _this.$store.commit("estoreVouchers/setModal", {
                        type: "storeVouchers",
                        status: true,
                        name: obj.name,
                        uuid: obj.uuid
                    });
                });
        },
        async getStoreVouchers(page) {
            let param = {
                page: page,
                payload: null
            };
            await this.$store.dispatch(
                "estoreVouchers/getStoreVouchers",
                param
            );
        }
    },
    filters: {
        toCurrency: function(value) {
            let parsedValue = parseFloat(value);
            if (typeof parsedValue !== "number") {
                return parsedValue;
            }
            return parsedValue.toFixed(2);
        }
    }
};
</script>
